import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs/Observable';
import { User } from '../model/user.class';
import { AuthHttp } from 'angular2-jwt/angular2-jwt';
import { ActivatedRoute, Router } from '@angular/router';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { Media } from '../model/media.class';
import { Version } from '../model/version.class';

@Component({
    selector: 'app-version-new',
    templateUrl: './version.new.component.html'
})
export class VersionNewComponent {

    public media: Media;
    public comment: string;
    public file: File;
    public versionStatus: string;

    public message = '';

    constructor(public userService: UserService, private route: ActivatedRoute, private router: Router, public modal: Modal) {
        this.userService.kiiUploader.clearQueue();
        this.route.params.subscribe(
            (params) => {
                const id = params['id'];
                userService.get(id, 'media').subscribe(data =>
                    this.media = data as Media
                );
            });
    }

    fileChange(event) {
        const fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            this.file = fileList[0];
        }
    }

    createVersion() {
        if (this.userService.kiiUploader.queue.length < 1) {
            this.showModalWindow('Keine Datei ausgewählt!', 'Bitte wählen Sie eine Datei zum Hochladen aus');
            return;
        }
        this.message = '';
        let error = false;
        this.versionStatus = this.userService.user.userType === this.userService.Admin
            ? this.userService.Approved : this.userService.New;
        for (const item of this.userService.kiiUploader.queue) {
            if (!item.file.name.endsWith('.kii')) {
                this.showModalWindow('Falsches Dateiformat', 'Nur .kii Dateien dürfen hochgeladen werden');
                error = true;
            }
        }
        if (error) {
            this.userService.kiiUploader.clearQueue();
            return;
        }
        this.userService.uploadKii(this.comment, this.media, this.media.versionCount + 1, this.versionStatus, this);
        
    }

    showModalWindow(title: string, message: string) {
        this.modal.alert()
            .size('sm')
            .isBlocking(true)
            .showClose(true)
            .keyboard(27)
            .titleHtml(title)
            .message(message)
            .open();
    }
}



// WEBPACK FOOTER //
// ./src/app/versionNew/version.new.component.ts